module.exports = __webpack_public_path__ + "img/modal-bg-teacher-welcome.9a634e65.png";